import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { PageContent } from "@/components/common/page-content"
import { RiskOverrideActions } from "@/features/risk/components/risk-override-actions"
import { RiskOverrideNote } from "@/features/risk/components/risk-override-note"
import { RiskChecks } from "@/features/risk/components/risk-checks"
import { RiskSubjectStanding } from "@/features/risk/components/risk-subject-standing"
import { RiskToDo } from "@/features/risk/components/risk-to-do"
import { riskQueries } from "@/queries/risk"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/risk/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      riskQueries.subject({ type: "individual", id: params.individualId })
    ),
  component: IndividualRiskPage,
})

function IndividualRiskPage() {
  const { individualId } = Route.useParams()
  const subject = { type: "individual", id: individualId } as const

  return (
    <>
      <PageHeader
        title="Risk"
        actions={<RiskOverrideActions subject={subject} />}
      />
      <PageContent>
        <RiskSubjectStanding subject={subject} />
        <RiskToDo subject={subject} />
        <RiskChecks subject={subject} />
        <RiskOverrideNote subject={subject} />
      </PageContent>
    </>
  )
}
